import Base from "../base";

export default class OrigenServices extends Base {
    static endpointUrl = "empresas/origenes/"
}